<template>
  <div class="elevatorAlarm">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-cascader v-model="threeLevelVal" :options="threeLevelData" clearable :props="{ checkStrictly: true }" placeholder="请选择所在区域"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="gardenName" placeholder="请输入所在小区"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="unitinnernum" placeholder="请输入安装位置"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="registercode" placeholder="请输入注册代码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="devName">
            <el-option label="请选择设备类别" value=""></el-option>
            <el-option label="曳引与强制驱动电梯" value="曳引与强制驱动电梯"></el-option>
            <el-option label="自动扶梯" value="自动扶梯"></el-option>
            <el-option label="曳引驱动乘客电梯" value="曳引驱动乘客电梯"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="type">
            <el-option label="请选择告警类型" value=""></el-option>
            <el-option label="困人" value="1"></el-option>
            <el-option label="冲顶" value="2"></el-option>
            <el-option label="蹲底" value="3"></el-option>
            <el-option label="反复开门" value="4"></el-option>
            <el-option label="基准层非平层" value="5"></el-option>
            <el-option label="运行中开门" value="6"></el-option>
            <el-option label="长时间开门检测" value="7"></el-option>
            <el-option label="轿厢检修" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="installDate" type="daterange" value-format="timestamp" range-separator="至"
            start-placeholder="告警开始日期" end-placeholder="告警结束日期">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="commit()">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="GardenName" label="所在小区" width="200">
        </el-table-column>
        <el-table-column prop="Place" label="安装位置" width="300">
        </el-table-column>
        <el-table-column prop="Registercode" label="注册代码" width="230">
        </el-table-column>
        <el-table-column prop="DevName" label="电梯类型" width="200">
        </el-table-column>
        <el-table-column prop="equipmentType" label="告警来源">
        </el-table-column>
        <el-table-column prop="type" label="告警类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">困人</span>
            <span v-if="scope.row.type == 2">冲顶</span>
            <span v-if="scope.row.type == 3">蹲底</span>
            <span v-if="scope.row.type == 4">反复开门</span>
            <span v-if="scope.row.type == 5">基准层非平层</span>
            <span v-if="scope.row.type == 6">运行中开门</span>
            <span v-if="scope.row.type == 7">长时间开门检测</span>
            <span v-if="scope.row.type == 8">轿厢检修</span>
          </template>
        </el-table-column>
        <el-table-column prop="gjTime" label="告警时间">
          <template slot-scope="scope">
            {{ scope.row.gjTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)">详情</el-button>
            <el-button @click="videoDetail(scope.row)">实时</el-button>
            <!-- <el-button @click="detail(scope.row)">图片</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 详情弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" style="padding:0 30px;" @closed="handleDialogClosed">
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws3"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="注册代码" prop="Registercode">
          <el-input type="text" v-model="ruleForm.Registercode" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="所属区域" prop="districtName">
          <el-input type="text" v-model="ruleForm.districtName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="所在小区" prop="GardenName">
          <el-input type="text" v-model="ruleForm.GardenName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="安装位置" prop="Place">
          <el-input type="text" v-model="ruleForm.Place" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="告警类型" prop="type">
          <el-input v-if="ruleForm.type == 1" type="text" value="困人" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 2" type="text" value="冲顶" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 3" type="text" value="蹲底" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 4" type="text" value="反复开门" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 5" type="text" value="基准层非平层" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 6" type="text" value="运行中开门" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 7" type="text" value="长时间开门检测" disabled class="item-input"></el-input>
          <el-input v-if="ruleForm.type == 8" type="text" value="轿厢检修" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="告警时间" prop="gjTime">
          <el-input type="text" :value="ruleForm.gjTime|time" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="使用单位" prop="Useunitidname">
          <el-input type="text" v-model="ruleForm.Useunitidname" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="联系人" prop="DutyPersonName">
          <el-input type="text" v-model="ruleForm.DutyPersonName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="联系电话" prop="DutyPersonPhone">
          <el-input type="text" v-model="ruleForm.DutyPersonPhone" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="维保单位" prop="Makeunitname">
          <el-input type="text" v-model="ruleForm.Makeunitname" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="联系人" prop="Maintanman">
          <el-input type="text" v-model="ruleForm.Maintanman" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="联系电话" prop="Cqphone">
          <el-input type="text" v-model="ruleForm.Cqphone" disabled class="item-input"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:elevatorAlarm
   *@Description:电梯物联网电梯告警
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.elevatorAlarm',
    data() {
      return {
        threeLevelVal: [],
        threeLevelData: [], // 省市区三级联动数据
        tableData: [], // table列表数据
        threeId: '', // 三级id
        threeType: 3, // 三级type
        gardenId: '', // 选择园区的id（模糊查询）
        gardenName: '', // 园区名称（模糊查询）
        unitinnernum: '', // 安装位置（模糊查询）
        registercode: '', // 注册代码（模糊查询）
        devName: '', // 电梯类型（模糊查询）
        type: '', // 告警类型（模糊查询）
        installDate: '', // 告警起始时间（模糊查询）
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        ruleForm: '', // 查看详情数据
        diaIsShow: false, // 弹框是否显示
        titleShow: '设备信息', // 弹框标题

      }
    },
    watch: {},
    created() {
      this.getThreeLevel()
      this.getData()
    },
    methods: {
      // 格式化三级省市区联动数据
      rewriteKey(val) {
        val.forEach(item => {
          item.label = item.name
          item.value = item.id
          if (item.children.length > 0) {
            this.rewriteKey(item.children)
          } else {
            delete item.children
          }
        })
      },
      // 获取三级省市区联动数据
      getThreeLevel() {
        this.$get(
          `aapi/liftMonitorThreeLevel`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.threeLevelData = res.list
              this.rewriteKey(this.threeLevelData)
              let obj = {
                label: '全部',
                name: '',
                parentId: '',
                type: 1,
                value: '',
              }
              this.threeLevelData.unshift(obj)
              console.log(this.threeLevelData)
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 获取列表数据
      getData() {
        if (this.threeLevelVal.length == 1) {
          this.threeId = this.threeLevelVal[0]
          this.threeType = 1
        } else if (this.threeLevelVal.length == 2) {
          this.threeId = this.threeLevelVal[1]
          this.threeType = 2
        } else if (this.threeLevelVal.length == 3) {
          this.threeId = this.threeLevelVal[2]
          this.threeType = 3
        } else {
          this.threeId = ''
          this.threeType = ''
        }
        if (this.installDate != null && this.installDate.length > 0 && this.installDate != '') {
          this.startTs = this.installDate[0]
          this.endTs = this.installDate[1]
        } else {
          this.startTs = ''
          this.endTs = ''
        }
        let loading = this.$loading()
        this.$get(
          `aapi/liftAlertList?threeId=${this.threeId}&threeType=${this.threeType}&gardenName=${this.gardenName}&unitinnernum=${this.unitinnernum}&registercode=${this.registercode}&devName=${this.devName}&type=${this.type}&startTs=${this.startTs}&endTs=${this.endTs}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 详情
      detail(rowData) {
        this.ruleForm = rowData
        this.diaIsShow = true
      },
      // 实时监测详情
      videoDetail(rowData) {
        this.$router.push({
          name: 'realTimeMonitoringDetail',
          query: {
            object: rowData
          }
        })
      },
      // 监听关闭dialog
      handleDialogClosed() {

      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .elevatorAlarm {
    .el-dialog__body {
      padding: 20px 40px 20px 20px !important;
    }
    .el-input.is-disabled .el-input__inner {
      color: #606266;
    }
    .el-cascader{
      line-height: 32px;
    }
  }
</style>